module.exports = __webpack_public_path__ + "static/media/dpk.05377c4e.png";